module.exports = __webpack_public_path__ + "static/joc_06-aea47c1ae868e3cb63cd937c58120d95.jpg";